module.exports = __webpack_public_path__ + "static/media/image_22.1f5585f7.png";